import { filmsApi } from "../api/filmsApi";

/**
 * One talent's job totals for a date range, as the server aggregates them.
 * Hours carry 2 decimals and total 4, the same scaling the Job fields use.
 */
export type JobTalentSummary = {
  talentID: number;
  hours: number;
  total: number;
  /**
   * `total` restricted to jobs that logged hours, so a rate can be worked out
   * without flat fees and stipends inflating it.
   */
  hourlyEarned: number;
};

/**
 * Bounds for a summary. Omit either end to leave that side unbounded.
 * Both are RFC3339 instants: the server compares them directly, so the caller
 * decides where its days begin.
 */
export type JobSummaryArgs = {
  from?: string;
  to?: string;
};

export const jobSummaryEndpoints = filmsApi.injectEndpoints({
  endpoints: (build) => ({
    getJobTalentSummaries: build.query<JobTalentSummary[], JobSummaryArgs>({
      query: (args) => ({ url: `jobs/talentSummary`, params: args }),
      // Aggregated from jobs, so it goes stale whenever a job does.
      providesTags: ["jobs"],
    }),
  }),
});

export const { useGetJobTalentSummariesQuery } = jobSummaryEndpoints;
